<div class="section-ctnr">
    <form pcgSubmitUrl="api/Administration/Users/SaveUser" (messageReceive)="saveUser($event)" [formGroup]="formGroup">
        <div>
            <br />
            <div class="row d-flex justify-content-around">
                <div class="d-flex align-items-center">
                    <pcg-control-group label="Username" [validations]="userNameValidation">
                        <input
                            pcgControlRef
                            class="form-control"
                            type="text"
                            formControlName="userName"
                            (change)="handleUsernameEvents()"
                            id="txtUserName"
                        />
                    </pcg-control-group>

                    @if (canSeePasswordButtons && !isSSO) {
                        <div>
                            <input
                                type="button"
                                (click)="resetPassword(false, false)"
                                class="btn btn-save btn-sm space-buttons"
                                ngbTooltip="Send user a reset password email with their username and the ability to choose a new password."
                                value="Reset Password"
                                id="btnResetPassword"
                            />
                        </div>
                    }
                    @if (isCurrentUser && !isSSO) {
                        <div>
                            <input
                                type="button"
                                value="Change Password"
                                (click)="openChangePasswordModal()"
                                class="btn btn-save btn-sm space-buttons"
                            />
                        </div>
                    }
                </div>

                <div class="d-flex align-items-center">
                    <pcg-control-group label="Permission" id="resize-permission">
                        @if (canManageUsers) {
                            <pcg-select
                                placeholder="Select an Permission"
                                [sendFormData]="false"
                                pcgControlRef
                                dataSource="api/Select/Permissions"
                                formControlName="permissionId"
                                id="resize-permission"
                                (change)="handlePermissionEvents()"
                            ></pcg-select>
                        }
                        @if (!canManageUsers) {
                            <input pcgControlRef type="text" class="form-control" formControlName="permission" />
                            <input pcgControlRef type="hidden" class="form-control" formControlName="permissionId" />
                        }
                    </pcg-control-group>

                    <div>
                        <input
                            type="button"
                            value="Permissions Info"
                            (click)="openPermissionsInfoModal()"
                            class="btn btn-save btn-sm space-buttons"
                        />
                    </div>
                </div>
            </div>

            <pcg-fixed-buttons>
                @if (!isCurrentUser || canManageUsers) {
                    <a class="btn btn-cancel btn-lg" backButton="/users/list">Back</a>
                }
            </pcg-fixed-buttons>
        </div>
    </form>
</div>
